import React from "react";
import PropTypes from "prop-types";
import {
  Container,
  Illustration,
  Title,
  SubTitle
} from "./styled/live-preview";

function LivePreview({ illustration, title, subTitle, className }) {
  return (
    <Container className={`preview ${className || ""}`}>
      <Illustration aria-hidden className="preview-illustration">
        {illustration}
      </Illustration>
      <Title
        title={title}
        className="font-primary preview-title"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      {subTitle && (
        <SubTitle className="preview-sub-title">{subTitle}</SubTitle>
      )}
    </Container>
  );
}

LivePreview.propTypes = {
  illustration: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

export default LivePreview;
